/**
 * Reactions JS controller.
 */

// Use jQuery as $ within this file scope.
const $ = jQuery;

/**
 * Class Reactions
 */
class Reactions {

    /**
     * Class constructor is for binding class properties.
     */
    constructor() {
    }

    /**
     * This functions is run after all script classes have been instantiated.
     * Use this if you need to access some other script instances before the document ready event.
     */
    init() {
    }

    /**
     * Cache DOM elements and variables for use in the class's methods
     */
    cache() {

        // Get reactions to post
        this.getReactions();

        // Reactions container
        this.reactionsContainer = $( '#ajax-reactions' );

        if ( this.reactionsContainer.length ) {

            // Local run-time objects and parameters
            this.reactionsKey = 'PohjantahtiReactions';
            this.reactions    = this.getCachedReactions();
            this.postID       = parseInt( this.reactionsContainer.data( 'post-id' ) );
            this.reacted      = this.reactions.hasOwnProperty( this.postID );
            this.shareButtons = this.reactionsContainer.next( '.share-buttons' );

            // Basic validation for postID
            if ( ! this.postID || ! Number.isInteger( this.postID ) ) {
                this.reacted = true;
            }

            // Disable reactions and show share buttons if user has already reacted to current post
            if ( this.reacted ) {
                this.disableReactions();
                this.showShareButtons();
            }

        }

    }

    /**
     * All common events
     */
    events() {

        // When reaction icon is clicked, update reaction count and toggle
        // visibility of share buttons.
        this.reactionsContainer.on( 'click.reactions', '.js-reaction', ( e ) =>  {
            this.saveReaction( e );
        });

    }

    /**
     * Get reaction counts
     */
    getReactions() {

        // Parameters
        const $el = $( '#ajax-reactions' );
        /* eslint-disable */
        const post_id = parseInt( $( '#ajax-reactions' ).data( 'post-id' ) );
        /* eslint-enable */

        // Get the reactions
        dp( 'Reactions/ReactionButtons', {
            partial: 'reaction-buttons',
            /* eslint-disable */
            args: {
                post_id: post_id
            }
        }).then( data  => {

            // Show reactions
            $el.html( data.success );

            // Activate reaction button events
            this.events();
        }).catch( error => {
            console.error( error );
        });
    }

    /**
     * Update reaction count
     *
     * @param {event object} e
     */
    saveReaction( e ) {

        // Stop propagation
        Theme.Common.stop( e );

        // Parameters
        const $target = $( e.currentTarget );
        const $count  = $target.find( '.js-reaction-count' );
        const key     = parseInt( $target.data( 'key' ) );
        /* eslint-disable */
        const post_id = parseInt( $( '#js-reactions' ).data( 'post-id' ) );
        /* eslint-enable */

        // Update reactions cache
        this.reactions[ this.postID ] = key;
        this.setCachedReactions( this.reactions );

        // Temporarily replace count with a spinner
        $count.text( '' );
        const $spinner = $( '<i>' )
            .addClass( 'fa fa-spinner fa-spin' )
            .attr( 'title', 'Tallennetaan reaktiota...' )
            .appendTo( $count );

        // Update reaction count
        dp( 'Reactions/SaveReaction', {
            /* eslint-disable */
            args: {
                key: key,
                post_id: post_id
            }
        }).then( data => {
        
            // Process response
            const countVal = data.success.Reactions ? parseInt( data.success.Reactions.SaveReaction ) : null;
            if ( typeof countVal !== null && Number.isInteger( countVal ) ) {

                // Update reaction counter (this also removes the spinner)
                $count.text( countVal );

            }

            // Disable reactions and show share buttons
            this.disableReactions();
            this.showShareButtons();
        }).catch( error => {

            // Replace spinner with error indicator
            $spinner.remove();
            const $error = $( '<i>' )
                .addClass( 'fa fa-exclamation-triangle' )
                .attr( 'title', 'Reaktion tallennus epäonnistui – yritä myöhemmin uudelleen.' )
                .appendTo( $count );
        })

        // Disable reactions and show share buttons
        this.disableReactions();
        this.showShareButtons();

    }

    /**
     * Disable reactions
     */
    disableReactions() {

        // Remove reaction event
        this.reactionsContainer.off( 'click.reactions' );

        // Disable reaction buttons and add class 'disabled' to reactions parent
        this.reactionsContainer
            .addClass( 'disabled' )
            .find( 'button' )
                .attr( 'disabled', 'disabled' );

    }

    /**
     * Show share buttons
     */
    showShareButtons() {
        if ( this.shareButtons.length ) {
            this.shareButtons.show();
        }
    }

    /**
     * Fetch reactions from cache to class property
     *
     * @return {object} Cached reactions or new object
     */
    getCachedReactions() {

        // Placeholder and default value for reactions
        let reactions = {};

        // Reaction data from localStorage
        if ( this.localStorageSupported() ) {
            const storedReactions = window.localStorage.getItem( this.reactionsKey );
            reactions = this.parseReactions( storedReactions );
        }

        // Reaction data from cookie
        if ( ! reactions.length ) {
            const cookieReactions = this.getCookie( this.reactionsKey );
            reactions = this.parseReactions( cookieReactions );
        }

        // Update reactions cache (this also replicates cache from localStorage to cookie and vice versa)
        this.setCachedReactions( reactions );

        return reactions;

    }

    /**
     * Store reactions from class property to cache
     *
     * @param {object} reactions Reactions object
     */
    setCachedReactions( reactions ) {

        // Bail out early if reactions parameter is invalid
        if ( ! reactions || typeof reactions !== 'object' ) {
            return false;
        }

        // Store reactions to localStorage
        if ( this.localStorageSupported() ) {
            window.localStorage.setItem(
                this.reactionsKey,
                JSON.stringify( reactions )
            );
        }

        // Store reactions to cookie
        this.setCookie(
            this.reactionsKey,
            JSON.stringify( reactions )
        );

    }

    /**
     * Parse reaction from (JSON) string
     *
     * @param {string} string JSON as a string
     * @return {object} Reactions as an object, or empty object if data is invalid
     */
    parseReactions( string ) {

        // Placeholder and default value
        let reactions = {};

        // Attempt to parse string as JSON
        if ( string && typeof string === 'string' ) {
            try {

                // Parse string to JSON
                string = JSON.parse( string );
                if ( typeof string === 'object' ) {
                    reactions = string;
                }

            } catch ( error ) {

                // Error, do nothing

            }
        }

        return reactions;

    }

    /**
     * Check if localStorage is available
     *
     * Note: it is not enough to test if window.localStorage exists, because some browsers
     * may have this, yet still prevent storing data in localStorage (in private mode etc.)
     *
     * @return {bool} Boolean indicating if localStorage is available.
     */
    localStorageSupported() {
        try {
            const testKey = 'Test';
            window.localStorage.setItem( this.reactionsKey + testKey, testKey );
            window.localStorage.removeItem( this.reactionsKey + testKey );
            return true;
        } catch ( e ) {
            return false;
        }
    }

    /**
     * Store value to cookie
     *
     * @param {string} key
     * @param {mixed} value
     */
    setCookie( key, value ) {
        document.cookie = key + '=' + value + '; path=/';
    }

    /**
     * Get value from cookie
     *
     * @param {string} key
     * @return {mixed} value or null
     */
    getCookie( key ) {
        const cookieString = '; ' + document.cookie;
        const cookies      = cookieString.split( '; ' + key + '=' );
        return cookies.length === 2 ? cookies.pop().split( ';' ).shift() : null;
    }

    /**
     * Run when the document is ready.
     */
    docReady() {
        this.cache();
        if ( this.reactionsContainer.length && ! this.reacted ) {
            this.events();
        }
    }
}

// Export the class reference.
module.exports = Reactions;



// WEBPACK FOOTER //
// ./assets/scripts/reactions.js